import RequestResourceSuccessById from 'ia-react-core/~/actions/resource/RequestResourceSuccessById';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import { AxiosResponse } from 'axios';
import requestResourceSuccessById from '../../../actions/resource-fn/requestResourceSuccessById';
import clearResourceDataById from '../../../actions/resource-fn/clearResourceDataById';
import clearResourceDataByName from '../../../actions/resource-fn/clearResourceDataByName';
import { ResourceComposedProps } from './Resource';

export default function resourceDataReducer<
  Data,
  Error = {},
>(state: Data, action: CoreAction, { resourceId, name }: ResourceComposedProps<Data, Error>) {
  switch (action.type) {
    case `${requestResourceSuccessById.type}/${resourceId}`:
      return reduceRequestData<Data>(state, action as RequestResourceSuccessById);
    case `${clearResourceDataById.type}/${resourceId}`:
    case `${clearResourceDataByName.type}/${name}`:
      return reduceClearRequestData();
    default:
      return state;
  }
}

function reduceRequestData<Data>(state: Data, { request }: RequestResourceSuccessById) {
  return (request as AxiosResponse).data as Data;
}

function reduceClearRequestData(): undefined {
  return undefined;
}
